//用于浏览器持久化的封装,支持嵌套字段修改
import { browser } from "$app/environment";
import { clientData } from "$lib/client-data/index.svelte.js";

const createAutoStorage = (key, state = {}, storage = localStorage) => {
  Object.assign(state, JSON.parse(storage.getItem(key) || "{}"));
  const persist = () => storage.setItem(key, JSON.stringify(state));
  const watch = (obj) =>
    new Proxy(obj, {
      get: (target, prop) => {
        const val = target[prop];
        return typeof val === "object" && val ? watch(val) : val;
      },
      set: (target, prop, value) => ((target[prop] = value), persist(), true),
      deleteProperty: (target, prop) => (delete target[prop], persist(), true),
    });
  return watch(state);
};

export const local = browser ? createAutoStorage("local") : {};
export const session = browser ? createAutoStorage("session", {}, sessionStorage) : {};
